interface SeriesIconProps {
  icon: string
  size?: 'sm' | 'md' | 'lg' | 'xl' | '2xl'
  className?: string
}

const sizeClasses = {
  sm: 'w-5 h-5',
  md: 'w-8 h-8',
  lg: 'w-10 h-10',
  xl: 'w-12 h-12',
  '2xl': 'w-16 h-16'
}

export default function SeriesIcon({ icon, size = 'md', className = '' }: SeriesIconProps) {
  // Check if icon is an SVG path or an emoji
  const isSvgPath = icon.startsWith('/') || icon.startsWith('http')
  
  if (isSvgPath) {
    return (
      <img 
        src={icon} 
        alt="Series icon" 
        className={`${sizeClasses[size]} ${className}`}
      />
    )
  }
  
  // Emoji fallback
  const emojiSizeClasses = {
    sm: 'text-lg',
    md: 'text-2xl',
    lg: 'text-3xl',
    xl: 'text-4xl',
    '2xl': 'text-6xl'
  }
  
  return (
    <span className={`${emojiSizeClasses[size]} ${className}`}>
      {icon}
    </span>
  )
}
